export const CHAT_SOURCES = {
  endUser: "endUser",
  whatsapp: "whatsapp",
}

export const getChatSource = chat => {
  if (!chat) return null

  if (
    chat.type === CHAT_SOURCES.endUser ||
    chat.chatType === CHAT_SOURCES.endUser ||
    chat.lastMessage?.chatType === CHAT_SOURCES.endUser ||
    chat.endUser
  ) {
    return CHAT_SOURCES.endUser
  }

  if (chat.client || chat.whatsappID || chat.lastMessage?.whatsappID) {
    return CHAT_SOURCES.whatsapp
  }

  return null
}

export const getChatSourceLabel = chat => {
  const source = getChatSource(chat)

  if (source === CHAT_SOURCES.endUser) return "Inspection app"
  if (source === CHAT_SOURCES.whatsapp) return "WhatsApp"

  return "Unknown source"
}
